import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const RevenueChart = ({ data = [], monthFilter = '', yearFilter = '' }) => {
  const chartData = data;

  // Definir o período sendo exibido
  const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

  const getPeriodText = () => {
    if (monthFilter && yearFilter) {
      return `${months[parseInt(monthFilter) - 1]} de ${yearFilter}`;
    } else if (monthFilter) {
      return months[parseInt(monthFilter) - 1];
    } else if (yearFilter) {
      return `Ano ${yearFilter}`;
    } else {
      const now = new Date();
      return `Ano ${now.getFullYear()}`;
    }
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
          <p className="font-medium text-gray-900">{`Período: ${label}`}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ color: entry.color }} className="text-sm">
              {`${entry.dataKey}: R$ ${entry.value.toLocaleString('pt-BR')}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">
          Receitas vs Despesas
        </h3>
        <span className="text-sm font-medium text-muted">
          {getPeriodText()}
        </span>
      </div>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
            <XAxis 
              dataKey="nome" 
              stroke="#6b7280" 
              fontSize={12}
              angle={-45}
              textAnchor="end"
              height={60}
            />
            <YAxis stroke="#6b7280" fontSize={12} tickFormatter={(value) => `R$ ${value}`} />
            <Tooltip content={<CustomTooltip />} />
            <Line type="monotone" dataKey="receita" stroke="#22c55e" strokeWidth={2} name="Receita" />
            <Line type="monotone" dataKey="despesas" stroke="#ef4444" strokeWidth={2} name="Despesas" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueChart;
